export default __webpack_public_path__ + "static/media/HuckNoBackground.90593168.png";